import { useEffect } from 'react';

const BOOST_Z = '10050';
const MARK = 'data-not-applicable-portal-boosted';

export function useHangarFloatingPortalZIndexBoost(active: boolean) {
  useEffect(() => {
    if (!active) return;

    const observedPortals = new WeakSet<Element>();

    const boost = () => {
      document.querySelectorAll<HTMLElement>('[data-floating-ui-portal]').forEach((el) => {
        el.setAttribute(MARK, '');
        el.style.setProperty('z-index', BOOST_Z, 'important');
      });
      document.querySelectorAll<HTMLElement>('[data-floating-ui-portal] [role="listbox"]').forEach(
        (listbox) => {
          let node: HTMLElement | null = listbox;
          while (node && node !== document.body) {
            const { position } = globalThis.getComputedStyle(node);
            if (position === 'fixed' || position === 'absolute') {
              node.setAttribute(MARK, '');
              node.style.setProperty('z-index', BOOST_Z, 'important');
              break;
            }
            node = node.parentElement;
          }
        },
      );
    };

    const attachPortalSubtreeObservers = (observer: MutationObserver) => {
      document.querySelectorAll<HTMLElement>('[data-floating-ui-portal]').forEach((el) => {
        if (!observedPortals.has(el)) {
          observedPortals.add(el);
          observer.observe(el, { childList: true, subtree: true });
        }
      });
    };

    const observer = new MutationObserver(() => {
      boost();
      attachPortalSubtreeObservers(observer);
    });

    boost();
    attachPortalSubtreeObservers(observer);
    observer.observe(document.body, { childList: true, subtree: false });

    return () => {
      observer.disconnect();
      document.querySelectorAll<HTMLElement>(`[${MARK}]`).forEach((el) => {
        el.style.removeProperty('z-index');
        el.removeAttribute(MARK);
      });
    };
  }, [active]);
}
